export const NETWORK_ON = 'NETWORK_ON'
export const NETWORK_OFF = 'NETWORK_OFF'

export interface NetworkState {
  isConnected?: boolean
}
